module.exports = __webpack_public_path__ + "static/media/RestAPI.0868f8b8.svg";